// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatMessage_container__OCyfF {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
}

.ChatMessage_content__eWGP3 {
    width: 100%;
    overflow: hidden;
}

.ChatMessage_content_suggestion__Lh7Y0 {
    /* margin-bottom: 85px; */
    margin-bottom: 60px;
}

.ChatMessage_item_box__a7Fjd {
    width: 60%;
    margin: 0 auto;
}

::selection {
    background-color: #cce2ff;
    color: rgba(0,0,0,.87);
}

.ChatMessage_content_none__E0BDV {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    flex-grow: 1; /* 自动填充剩余空间 */
}

/* 自定义滚动条 */
.ChatMessage_content_none__E0BDV::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

.ChatMessage_content_none__E0BDV::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ChatMessage_content_none__E0BDV::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ChatMessage_input_container__z3uiw {
    width: 100%;
    padding: 0 10px;
    padding-right: 80px;
}
.ChatMessage_input_box__EFQPp {
    width: 60%;
    padding-right: 50px;
    margin: 0 auto;
}
.ChatMessage_stop_responding__T87HW {
    width: 110px;
    height: 42px;
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
}
.ChatMessage_content_mobile__cpqzb .ChatMessage_input_container__z3uiw {
    padding: 0 20px 20px!important;
}
.ChatMessage_content_ios_mobile__9QWMU .ChatMessage_input_container__z3uiw {
    padding: 0 20px 40px!important;
}
.ChatMessage_content_mobile__cpqzb .ChatMessage_input_box__EFQPp {
    width: 100%!important;
    padding-right: 0!important;
}
.ChatMessage_content_mobile__cpqzb .ChatMessage_item_box__a7Fjd {
    width: 100%;
}
.ChatMessage_content_mobile__cpqzb .ChatMessage_content_suggestion__Lh7Y0 {
    margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ChatMessage/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY,EAAE,aAAa;AAC/B;;AAEA,WAAW;AACX,qDAAkC,UAAU;IACxC,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA,2DAAwC,WAAW;IAC/C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;AAC/B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.content {\n    width: 100%;\n    overflow: hidden;\n}\n\n.content_suggestion {\n    /* margin-bottom: 85px; */\n    margin-bottom: 60px;\n}\n\n.item_box {\n    width: 60%;\n    margin: 0 auto;\n}\n\n::selection {\n    background-color: #cce2ff;\n    color: rgba(0,0,0,.87);\n}\n\n.content_none {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    width: 100%;\n    flex-grow: 1; /* 自动填充剩余空间 */\n}\n\n/* 自定义滚动条 */\n.content_none::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n}\n\n.content_none::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.content_none::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.input_container {\n    width: 100%;\n    padding: 0 10px;\n    padding-right: 80px;\n}\n.input_box {\n    width: 60%;\n    padding-right: 50px;\n    margin: 0 auto;\n}\n.stop_responding {\n    width: 110px;\n    height: 42px;\n    position: absolute;\n    bottom: 100px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n.content_mobile .input_container {\n    padding: 0 20px 20px!important;\n}\n.content_ios_mobile .input_container {\n    padding: 0 20px 40px!important;\n}\n.content_mobile .input_box {\n    width: 100%!important;\n    padding-right: 0!important;\n}\n.content_mobile .item_box {\n    width: 100%;\n}\n.content_mobile .content_suggestion {\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatMessage_container__OCyfF`,
	"content": `ChatMessage_content__eWGP3`,
	"content_suggestion": `ChatMessage_content_suggestion__Lh7Y0`,
	"item_box": `ChatMessage_item_box__a7Fjd`,
	"content_none": `ChatMessage_content_none__E0BDV`,
	"input_container": `ChatMessage_input_container__z3uiw`,
	"input_box": `ChatMessage_input_box__EFQPp`,
	"stop_responding": `ChatMessage_stop_responding__T87HW`,
	"content_mobile": `ChatMessage_content_mobile__cpqzb`,
	"content_ios_mobile": `ChatMessage_content_ios_mobile__9QWMU`
};
export default ___CSS_LOADER_EXPORT___;
